
export type CreateSession401 = {
  message?: string;
  success?: boolean;
};
